import fromAnyToMessageV1 from 'utils/converters/backend/fromAnyToMessageV1.util';

const fromStatusToMessageV1 = (status) => fromAnyToMessageV1(`Unknown error with code ${String(status)}`);

// noinspection JSUnusedGlobalSymbols
export default fromStatusToMessageV1;
